import React from 'react';
import { flatten, uniq } from 'lodash';
import envConfig from '@/config/environment';
import { nonUserFacingTags } from '@/config/templates';
import SEO from '@/common/components/head/Seo';
import ClientOnly from '@/components/ClientOnly';
import Layout, { styles as layoutStyles } from '@/components/layouts/Public';
import Header from './Header';
import WidgetsTable from './WidgetsTable';
import WidgetsGallery from './WidgetsGallery';
import settings from './settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Templates = _ref => {
  let {
    widgets
  } = _ref;
  // Get unique tags
  const uniqueTags = uniq(flatten(widgets.map(_ref2 => {
    let {
      tags
    } = _ref2;
    return tags || [];
  })));
  const filters = uniqueTags.filter(tag => !nonUserFacingTags.includes(tag)).map(name => ({
    name,
    counter: widgets.reduce((acc, _ref3) => {
      let {
        tags
      } = _ref3;
      return acc += (tags || []).includes(name) ? 1 : 0;
    }, 0)
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SEO, {
      title: settings.title,
      description: settings.description,
      ogImageSrc: `${envConfig.baseUrl}${settings.images.openGraph}`
    }), /*#__PURE__*/_jsx(Layout, {
      children: /*#__PURE__*/_jsxs(ClientOnly, {
        children: [/*#__PURE__*/_jsx(Header, {
          className: layoutStyles.section,
          widgets: widgets,
          filters: filters,
          isLoaded: true
        }), /*#__PURE__*/_jsx(WidgetsGallery, {
          className: layoutStyles.section,
          widgets: widgets,
          filters: filters,
          isLoaded: true
        }), /*#__PURE__*/_jsx(WidgetsTable, {
          className: layoutStyles.section,
          widgets: widgets
        })]
      })
    })]
  });
};

export default Templates;